import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe, CurrencyPipe } from '@angular/common';
import { GlobalService } from '../services/global/global.service';

@Pipe({
  name: 'applyFormatter'
})
export class ApplyFormatterPipe implements PipeTransform {

  constructor(
    private datePipe: DatePipe, 
    private currencyPipe: CurrencyPipe,
    private _globalService: GlobalService
  ) {}

  transform(value: any, formatter: string): any {
    if (!formatter) {
      return value;
    }

    const [type, format] = formatter.split(/:(.+)/).map(item => item.trim());

    switch (type) {
      case 'date':
        return this.datePipe.transform(value, format);
      case 'currency':
        const currencyCode = format || 'USD';
        return this.currencyPipe.transform(value, currencyCode, 'symbol', '1.2-2');
      case 'secondsToTime':
        return this._globalService.secondsToTime(value);
      default:
        return value;
    }
  }
}
